export default __webpack_public_path__ + "static/media/quick-pay.8c62bd98.svg";